import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../../services/types";
import UserLinks from "../../components/organisms/UserLinks/UserLinks";
import { getAllTags } from "../../services/getAllTags";

const ProfilePage = () => {
  const { data: tags } = useQuery({
    queryFn: getAllTags,
    queryKey: [QueryKeys.TAGS],
    refetchOnMount: false,
  });
  const tagList = useMemo(() => tags?.data, [tags]);

  return (
    <div>
      <UserLinks tagList={tagList} />
    </div>
  );
};

export default ProfilePage;
